module.exports = __webpack_public_path__ + "img/Ausbruch.ca1b2ab9.jpg";